/**
 * Phase I Wave 2.5 R2 · <GatedRoute>
 * ──────────────────────────────────
 * Composition helper · wraps `<ProtectedRoute>` + `<FeatureGate>` so
 * route-level plan gating stays zero-touch on sealed page components.
 *
 * Usage inside App.js:
 *   <Route path="/app/seo/dashboard" element={
 *     <GatedRoute featureKey="seo_master_base">
 *       <SeoDashboardPage />
 *     </GatedRoute>
 *   } />
 *
 * The gate reads the user from `AuthContext` and applies the admin
 * bypass automatically (super_admin / admin always see the inner page).
 */
import React, { Suspense } from "react";
import ProtectedRoute from "@/components/ProtectedRoute";
import FeatureGate from "@/components/FeatureGate";
import PaywallUpsellCard from "@/components/paywall/PaywallUpsellCard";

export function GatedRoute({ featureKey, children, fallback }) {
    const effectiveFallback = fallback ?? <PaywallUpsellCard featureKey={featureKey} />;
    return (
        <ProtectedRoute>
            <Suspense fallback={<div className="min-h-screen bg-[#0A0A0A]" />}>
                <FeatureGate featureKey={featureKey} fallback={effectiveFallback}>
                    {children}
                </FeatureGate>
            </Suspense>
        </ProtectedRoute>
    );
}

export default GatedRoute;
